import { render, staticRenderFns } from "./billing-and-bank-details-form.vue?vue&type=template&id=2d41a274&lang=pug"
import script from "./billing-and-bank-details-form.vue?vue&type=script&lang=ts"
export * from "./billing-and-bank-details-form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports